import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useState } from "react";
import PropTypes from "prop-types";
import { equals } from "ramda";
import { RangeInput as Input } from "@base-ui";
import { useDebouncedValue, useCustomEffect } from "hooks";
import { jsx as _jsx } from "react/jsx-runtime";
var SingleRangeInput = function SingleRangeInput(props) {
  var id = props.id,
    selectable = props.selectable,
    current = props.current,
    onChange = props.onChange,
    legend = props.legend,
    hideLegend = props.hideLegend,
    style = props.style,
    className = props.className;
  var startIdx = selectable.findIndex(function (x) {
    return x.id === current.id;
  });
  var _useState = useState(startIdx),
    _useState2 = _slicedToArray(_useState, 2),
    currentStep = _useState2[0],
    setCurrentStep = _useState2[1];
  var debouncedCurrentStep = useDebouncedValue(300, currentStep);
  useCustomEffect(function () {
    if (!equals(debouncedCurrentStep, startIdx)) {
      onChange(debouncedCurrentStep);
    }
  }, [debouncedCurrentStep]);
  return /*#__PURE__*/_jsx(Input, {
    id: id,
    className: className,
    legend: legend,
    hideLegend: hideLegend,
    label: selectable[currentStep].label,
    steps: selectable.length - 1,
    value: currentStep,
    onChange: setCurrentStep,
    onStep: setCurrentStep,
    style: style
  });
};
SingleRangeInput.propTypes = {
  id: PropTypes.string.isRequired,
  selectable: PropTypes.array.isRequired,
  current: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  legend: PropTypes.string.isRequired,
  hideLegend: PropTypes.oneOf([true, false]),
  style: PropTypes.object,
  className: PropTypes.string
};
export default SingleRangeInput;